import React from 'react';
import OriginalMedicalDashboard from '../components/OriginalMedicalDashboard';

const OriginalMedicalDashboardPage = () => {
  return (
    <div>
      <OriginalMedicalDashboard />
    </div>
  );
};

export default OriginalMedicalDashboardPage;